import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "common/api/BaseQuery";
import {
  QuickContactColelctionJson,
  QuickContactFilter,
} from "../types/quickcontact.type";

export const websiteApi = createApi({
  reducerPath: "websiteApi",
  baseQuery: baseQuery(),
  endpoints: (builder) => ({
    // Api Public
    getSocials: builder.query<QuickContactColelctionJson, QuickContactFilter>({
      query(params) {
        return {
          url: "/sociallives/public",
          params: {
            ...params,
          },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSocialsQuery } = websiteApi;
